import Button from '@ui-kit/components/Button';
import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { Trans, useTranslation } from 'react-i18next';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';

type Props = ModalProps<{ idProtectCost: number }>;
const IdProtectInfo = ({ closeModal, payload: { idProtectCost } }: Props) => {
  const { t } = useTranslation('Modal');

  return (
    <Modal title={t('IdProtectInfo.title')}>
      <div className="flex flex-col gap-4">
        <p className="text-body-semibold">{t('IdProtectInfo.cost', { amount: idProtectCost })}</p>
        <p>{t('IdProtectInfo.body')}</p>

        <ul className="marker:text-text-brand [&_b]:text-icon-brand my-0 flex flex-col gap-1 pl-6 [&_b]:font-bold">
          <li>
            <Trans t={t} i18nKey="IdProtectInfo.item1" components={{ b: <b /> }} />
          </li>
          <li>
            <Trans t={t} i18nKey="IdProtectInfo.item2" components={{ b: <b /> }} />
          </li>
          <li>
            <Trans t={t} i18nKey="IdProtectInfo.item3" components={{ b: <b /> }} />
          </li>
        </ul>
      </div>
      <ModalActions>
        <Button onClick={closeModal}>{t('IdProtectInfo.button')}</Button>
      </ModalActions>
    </Modal>
  );
};

export default IdProtectInfo;
